import { styled } from "@mui/system";

export const StyledComeBackVerificationComponent = styled("div")(({ theme }) => ({
  // marginBottom: 40,
  maxWidth: theme.constants.containerWidth,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    boxSizing: "border-box",
    // paddingTop: "15vh",
    marginBottom: 0
  },
  "& .heading": {
    display: "none",
    marginBottom: "1rem",
    [theme.breakpoints.only("sm")]: {
      display: "block",
      marginTop: 0,
      fontSize: 38,
      lineHeight: "46px"
    }
  }
}));
